import { render, staticRenderFns } from "./FeaturedRunnerSection.vue?vue&type=template&id=f6a417f4&scoped=true&"
import script from "./FeaturedRunnerSection.vue?vue&type=script&lang=js&"
export * from "./FeaturedRunnerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a417f4",
  null
  
)

export default component.exports